import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input", "file"];

  disable(){
    this.fileTarget.classList.add("d-none")
    this.inputTarget.disabled = true
  }
}